import React from "react";
import { useTranslation } from "react-i18next";

const ModalCloseIcon = ({disabled = false}) => {
    const { t } = useTranslation();
    return (
        <button type="button" className="close" data-dismiss="modal" aria-label={t("Close")} disabled={disabled}/>
    );
};

export default ModalCloseIcon;